/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { Formik, Form } from 'formik';

import useToast from '../../../hooks/useToast';
import HeaderTable from '../../WorkReports/ViewOptionsContainer/DailyView/LineTableContainer/HeaderTable';
import SendToApproveAllMonthlyLines from '../MonthlyActionsButtons/MonthlyWorkReportActionButtons/SendToApproveAllMonthlyLines';
import {
  getDetailsMonthlyHeader,
  getMonthlyLocationByPositionsLines,
  getPtdByPositionAndLineService
} from '../../../services/monthlyServiceRequest';
import {
  formatFullDate,
  getFirstDayOfMonth,
  MONTHS,
  getLastDateOfMonth,
  formatsEnum
} from '../../../utils/formatUtils';
import InputCalendar from '../../Calendar/InputCalendar/InputCalendar';
import LoaderContext from '../../../context/LoaderProvider';
import { useWorkReportModals } from '../../../context/WorkReportModalsContext';
import { workReportLineStatus } from '../../../utils/dataStatus';
import { PositionLinePermissions } from '../RequestDetailTypes';
import NoWorkReports from '../../WorkReports/NoWorkReports';
import LineRowContainerGeneric from '../../WorkReports/LineRowContainerGeneric/LineRowContainerGeneric';
import { checkRol } from '../../../security';
import { notificador, proveedorNotificador } from '../../../security/constantsRols';
import ComponentWithTooltip from '../../ComponentWithTooltip/ComponentWithTooltip';
import colors from '../../../styles/colors.module.scss';
import { useFilterContext } from '../../../context/FilterDetailSDSContext';

const initialValues = {};

const MonthlyPositionLinesContainer = ({
  accordionData,
  lineName,
  month,
  positionLinePermissions,
  positionName,
  setRefreshFetch,
  showContentAccordion,
  unitMeasure,
  year,
  disabledEditStateCancelOrFinish,
  isOyM,
  notificaPP
}) => {
  const firstDayOfSSM = getFirstDayOfMonth(MONTHS.indexOf(month), year);
  const lastDayOfSSM = getLastDateOfMonth(MONTHS.indexOf(month), year);
  const lastDay = new Date(lastDayOfSSM);
  const firstDayMonth = new Date(firstDayOfSSM);

  firstDayMonth.setDate(firstDayMonth.getDate() + 1);

  lastDay.setDate(lastDay.getDate() + 1);
  const today = new Date();
  const intialDay =
    today < lastDay && today > firstDayMonth ? today.toISOString().split('T')[0] : lastDayOfSSM;

  const form = useRef();
  const { setNewToast } = useToast();
  const { id: idMSDS } = useParams();

  const { setLoader } = useContext(LoaderContext);
  const { setSelectedDate: setModalsContextDate } = useWorkReportModals();

  const [firstDayWithLine, setFirstDayWithLine] = useState();
  const [lastDayWithLine, setLastDayWithLine] = useState();
  const [changeInLines, setChangeInLines] = useState(false);
  const [daysWithLines, setDaysWithLines] = useState([]);
  const [linesToApprove, setLinesToApprove] = useState([]);
  const [newFetch, setNewFetch] = useState(false);
  const [selectedDate, setSelectedDate] = useState(intialDay);
  const [locations, setLocations] = useState([]);
  const [forceWindow, setForceWindow] = useState(null);
  const [isNotificationWindowOpen, setIsNotificationWindowOpen] = useState(null);
  const [validityDate, setValidityDate] = useState('');
  const { id: serviceRequestId } = useParams();
  const { filter } = useFilterContext();

  const getNotificationWindowState = async () => {
    setLoader(true);

    try {
      const { forzarVentanaNotificacion, fechaVigencia } = await getDetailsMonthlyHeader(
        serviceRequestId
      );

      setForceWindow(forzarVentanaNotificacion);
      setValidityDate(fechaVigencia);
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getNotificationWindowState();
  }, [serviceRequestId]);

  const isProviderOrNotifier = checkRol(proveedorNotificador) || checkRol(notificador);

  const ubicationMapper = (ubi) =>
    ubi?.map((line) => ({
      ...line,
      positionName,
      lineName,
      unidadMedida: unitMeasure,
      disabled:
        !(
          line.estadoEnum === workReportLineStatus.pendiente ||
          line.estadoEnum === workReportLineStatus.devolver
        ) ||
        // Se entiende que si no tiene permiso de enviar o rectificar
        // entonces NO tiene permiso de editar el input
        !positionLinePermissions.sendToApprove ||
        !positionLinePermissions.rectifyLine
    }));

  const colorCalendarMapper = (objectCalendar) => {
    const { fechasConCantidadesNotificadas, fechasConCantidadesNotificadasDevueltas } =
      objectCalendar;
    const datesWithQuantityNotified = fechasConCantidadesNotificadas
      ?.map((date) => ({
        color: fechasConCantidadesNotificadasDevueltas?.includes(date) ? '#FF0000' : '#312b2bc7',
        date
      }))
      ?.concat(
        fechasConCantidadesNotificadasDevueltas
          ?.filter((date) => !fechasConCantidadesNotificadas?.includes(date))
          ?.map((date) => ({ color: '#FF0000', date }))
      );

    return datesWithQuantityNotified;
  };

  const getLines = async (date) => {
    if (showContentAccordion) {
      setLoader(true);
      try {
        const typeUbications = () => {
          if (filter?.ubicationType) {
            return [filter?.ubicationType?.id];
          }
          if (filter?.tipoUbicacionesIds) {
            return filter?.tipoUbicacionesIds?.map((ubic) => ubic);
          }

          return [];
        };

        const ubications = () => {
          if (filter?.ubications) {
            return [filter?.ubications?.id];
          }
          if (filter?.ubicacionesIds) {
            return filter?.ubicacionesIds?.map((ubic) => ubic);
          }

          return [];
        };

        const body = {
          fecha: date,
          forzarVentanaNotificacion: forceWindow,
          fechaVigencia: validityDate,
          tipoUbicacionesIds: typeUbications(),
          ubicacionesIds: ubications()
        };
        const locationResponse = await getMonthlyLocationByPositionsLines(
          idMSDS,
          accordionData?.id,
          body
        );

        const positionLineResponse = await getPtdByPositionAndLineService(
          idMSDS,
          accordionData.numeroPosicion,
          accordionData.numeroLinea,
          date
        );

        setIsNotificationWindowOpen(locationResponse?.ventanaActiva);
        setDaysWithLines(colorCalendarMapper(positionLineResponse));
        setDaysWithLines(colorCalendarMapper(positionLineResponse));
        setSelectedDate(date);
        setLoader(false);
        setFirstDayWithLine(positionLineResponse.primeraFecha);
        setLastDayWithLine(positionLineResponse.ultimaFecha);
        setLocations(ubicationMapper(locationResponse.parteTrabajoDiaUbicaciones));
        setFirstDayWithLine(positionLineResponse.primeraFecha);
        setLastDayWithLine(positionLineResponse.ultimaFecha);
        setLoader(false);
      } catch (error) {
        setLoader(false);
        setNewToast({
          type: 'ERROR',
          message: error.message
        });
      }
    }
  };

  const handleChangeDate = (value) => {
    const dateToFetch = formatFullDate(value, formatsEnum.FORMAT_DATE_2);
    const dateSelected = formatFullDate(selectedDate, formatsEnum.FORMAT_DATE_2);

    // Si la fecha no cambio no hago el fetch
    if (dateSelected !== dateToFetch) getLines(dateToFetch);
  };

  const handleGoFirstLastDay = (firstDay = false) => {
    if (firstDay) {
      getLines(firstDayWithLine);
    } else {
      getLines(lastDayWithLine);
    }
  };

  useEffect(() => {
    getLines(selectedDate);
  }, [showContentAccordion, newFetch]);

  useEffect(() => {
    setLinesToApprove(locations);
    setLinesToApprove(locations);
    form?.current?.setValues({
      line: locations
    });
  }, [locations]);

  useEffect(() => {
    setLinesToApprove(form?.current?.values?.line);
  }, [changeInLines]);

  useEffect(() => {
    setModalsContextDate(selectedDate);
  }, [selectedDate]);

  const CalendarComponent = () => (
    <InputCalendar
      arrayDate={daysWithLines}
      // colorCalendar={notificationColorDay}
      colorCalendar={
        isNotificationWindowOpen ? colors.calendarOpenWindow : colors.calendarClosedWindow
      }
      handleChangeDate={(date) => handleChangeDate(date)}
      isMSDS
      maxDate={lastDayOfSSM}
      minDate={firstDayOfSSM}
      onClickFirstDay={() => handleGoFirstLastDay(true)}
      onClickLastDay={() => handleGoFirstLastDay()}
      selectDay={selectedDate}
      showNotification={!isOyM && isProviderOrNotifier}
    />
  );

  return (
    <>
      <div className="d-flex justify-content-end mt-4">
        {!isOyM && !isNotificationWindowOpen ? (
          <ComponentWithTooltip tooltipText="Fecha fuera de la ventana de notificación">
            {CalendarComponent()}
          </ComponentWithTooltip>
        ) : (
          CalendarComponent()
        )}
      </div>

      {locations?.length ? (
        <>
          <ul className="list_container">
            <HeaderTable location />
            <Formik initialValues={initialValues} innerRef={form}>
              {({ values }) => (
                <Form>
                  {values?.line?.map((line, index) => (
                    <li className="general_row_container" key={line.idParteDiario}>
                      <LineRowContainerGeneric
                        changeInLines={changeInLines}
                        disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
                        enableNotification={line.habilitaNotificacion}
                        forceWindow={forceWindow}
                        indexLine={index}
                        isNotificationWindowOpen={isNotificationWindowOpen}
                        line={line}
                        monthly
                        monthlyPositionLine
                        newFetch={newFetch}
                        notificaPP={notificaPP}
                        positionLinesPermissions={positionLinePermissions}
                        selectedDate={selectedDate}
                        setChangeInLines={setChangeInLines}
                        setLines={setLocations}
                        setNewFetch={setNewFetch}
                        setRefreshFetch={setRefreshFetch}
                        setWorkReportLines={setLocations}
                        typeOfUbication={{ id: line?.tipoUbicacionId }}
                      />
                    </li>
                  ))}
                </Form>
              )}
            </Formik>
          </ul>
          <hr />
          <SendToApproveAllMonthlyLines
            hasSendToApprovePermissions={positionLinePermissions.sendToApprove}
            newFetch={newFetch}
            selectedDate={selectedDate}
            setNewFetch={setNewFetch}
            workReportId={idMSDS}
            workReportLines={linesToApprove || []}
          />
        </>
      ) : null}
      {!locations?.length ? (
        // Esto significa que no tiene lineas en la fecha seleccionada
        <NoWorkReports subtitle=" " title="No hay ubicaciones para la fecha seleccionada" />
      ) : null}
    </>
  );
};

MonthlyPositionLinesContainer.propTypes = {
  accordionData: PropTypes.shape({
    nombre: PropTypes.string,
    id: PropTypes.number,
    numeroLinea: PropTypes.number,
    numeroPosicion: PropTypes.number
  }).isRequired,
  lineName: PropTypes.string,
  month: PropTypes.string.isRequired,
  positionLinePermissions: PositionLinePermissions.isRequired,
  positionName: PropTypes.string,
  setRefreshFetch: PropTypes.func.isRequired,
  showContentAccordion: PropTypes.bool.isRequired,
  unitMeasure: PropTypes.string,
  year: PropTypes.string.isRequired,
  disabledEditStateCancelOrFinish: PropTypes.bool.isRequired,
  isOyM: PropTypes.bool,
  notificaPP: PropTypes.bool.isRequired
};

MonthlyPositionLinesContainer.defaultProps = {
  positionName: '',
  lineName: '',
  unitMeasure: '',
  isOyM: false
};

export default MonthlyPositionLinesContainer;
